import { render, staticRenderFns } from "./Instalacion.vue?vue&type=template&id=5efd7e9e&scoped=true"
import script from "./Instalacion.vue?vue&type=script&lang=js"
export * from "./Instalacion.vue?vue&type=script&lang=js"
import style0 from "./Instalacion.vue?vue&type=style&index=0&id=5efd7e9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efd7e9e",
  null
  
)

export default component.exports